package br.com.texeratx.boardgametimeapp.data.model.dashboard

import kotlinx.serialization.Serializable

@Serializable
data class LastMatchesDTO(
    val matchId: Long,
    val gameName: String,
    val gameImageUrl: String? = null,
    val date: String,
    val duration: Int,
    val players: List<String>   // nomes dos jogadores
)
